;(function () {

var ProductLiTemplate = require('../views/templates/product-li.html');
var PaginationTemplate = require('../views/templates/pagination.html');

var debug = window.Cookies.get('rr_debug');

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function encodeFilters(filters) {
  filters = filters || [];
  return window.encodeURIComponent(filters.join(','));
}

function updateUrlParameters(filters, indexKey, page) {
  if (history.pushState) {
    filter = encodeFilters(filters);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?f='+filter+'&s='+indexKey+'&page='+page;
    window.history.pushState({ path: newurl }, '', newurl);
  }
}

function prepareProductData(hits) {
  var products = [];

  hits.forEach(function (hit) {
    var image = hit.product_image;
    var extension = image.split('.').pop();
    extension = '.' + extension.split('?')[0];

    hit.medium_image = image.split(extension)[0] + '_x311' + extension;
    hit.large_image = image.split(extension)[0] + '_x700' + extension;
    hit.display_price = '$' + hit.variants_min_price;
    hit.price = hit.variants_min_price;
    hit.url = '/products/'+hit.handle;

    /* Assume all variant options are identical for product */
    hit.variants.forEach(function (variant) {
      hit.inventory_policy = variant.inventory_policy;
      hit.inventory_management = variant.inventory_management;
      if (variant.compare_at_price) {
        hit.compare_at_price = parseFloat(variant.compare_at_price);
      }
    });

    var now = new Date().valueOf();
    var diffDays = (now - hit.published_date) / 1000 / 3600 / 24;

    if (diffDays < 10) {
      hit.badge = 'new';
    }

    if (hit.compare_at_price > hit.price) {
      hit.badge = 'sale';
    }

    if (hit.tags.indexOf('exclusive') !== -1) {
      hit.badge = 'exclusive';
    }

    if (hit.tags.indexOf('best-seller') !== -1) {
      hit.badge = 'best-seller';
    }

    products.push(hit);
  });

  // console.log(hits);
  return products;
}

var RefinementView = Backbone.View.extend({
  initialize: function () {
    this.filters = getParameterByName('f') ? getParameterByName('f').split(',') : [];
    this.client = algoliasearch('808GQH9HV4', '18d27a98c6c38e9629a162b57cd5de4a');

    this.indexKey = getParameterByName('s') || 'products_inventory_desc';
    this.index = this.client.initIndex(this.indexKey);
    this.page = parseInt(getParameterByName('page')) - 1 || 0;
    this.query = getParameterByName('q') || '';

    this.$container = $("#collection-container");
    this.collectionId = $('#collection-id').data('id');

    this.guid = window.App.guid();

    if (this.filters.length || this.indexKey !== 'products_inventory_desc') {
      this.setState(true);
    }

    /* Resize Logic */
    $(window).on('resize.'+this.guid, _.debounce(_.bind(this.resize, this)));
    /* Let fonts load, then resize */
    $(window).on('load', function () { $(window).trigger('resize'); });

    this.resize();
  },
  setState: function () {
    // console.log('setting state');
    var self = this;

    this.filters.forEach(function (filter) {
      self.$el.find('.filter .option').each(function () {
        var key = $(this).data('key');

        if (self.filters.indexOf(key) !== -1) {
          $(this).addClass('active');
        }
      });
    });

    this.$el.find('.sort select').val(this.indexKey);
    this.ajaxFilter();
  },
  resize: function () {
    var $filters = this.$el.find('.filter');
    var zoom = parseFloat($('html').css('zoom')) || 1;
    zoom = parseFloat(zoom);

    var $products = $('.products');
    var maxLeft = $products.offset().left + parseInt($products.css('padding-left'));
    var maxRight = $products.offset().left + parseInt($products.outerWidth()) - parseInt($products.css('padding-right'));

    $filters.each(function () {
      var tw = 0;

      var $options = $(this).find('.options');
      var $arrow = $options.find('.arrow');
      $options.css('width', '');

      $(this).find('.grouping').each(function () {
        var $el = $(this);
        var w = $el.outerWidth();
        tw += w;
      });

      tw = tw + 35;

      if ($(window).width() < 765) {
        tw = $(window).width() - 30;
      }

      $options.css({
        'width': tw,
        'margin-left': -tw/2
      });

      $arrow.css({
        'left': tw/2
      });

      var left = $options.offset().left;
      if (left < maxLeft) {
        var diff = maxLeft - left;

        $options.css({
          'margin-left': -tw/2 + diff
        });

        $options.find('.arrow').css({
          'left':  tw/2 - diff
        });
      }

      var right = left + $options.outerWidth();

      if (right > maxRight) {
        var diff = right - maxRight;

        $options.css({
          'margin-left': -tw/2 - diff
        });

        $options.find('.arrow').css({
          'left':  tw/2 + diff
        });        
      }

      if (window.App.touch && ($(window).width() < 765)) {
        $(this).addClass('no-hover');
      } else {
        $(this).removeClass('no-hover');
      }

    });

    /* Even for mobile */
    var $products = this.$container.find('.products').children();
    for (var i = 0; i < $products.length; i+=2) {
      var $left = $($products[i]).find('.content').css('height', '');
      var $right = $($products[i+1]).find('.content').css('height', '');

      var max = _.max([$left.outerHeight(true), $right.outerHeight(true)]);

      $left.css('height', max);
      $right.css('height', max);
    }

  },
  setFilterState: function () {
    var self = this;
    var allFilters = [];
    this.$el.find('.filter').each(function () {
      var $el = $(this);
      var filters = [];

      $el.find('.option.active').each(function () {
        filters.push($(this).text());
        allFilters.push($(this).text());
      });

      $el.find('.title > span').remove();
      $el.find('.title').removeClass('active');

      if (filters.length) {
        $el.find('.title').append($('<span>'+filters.join(', ')+'</span>'));
        $el.find('.title').addClass('active');
      }
  
    });

    this.$el.find('.mobile-title > span').text('Filter By:');
    if (allFilters.length) {
      this.$el.find('.mobile-title > span').text('Filtering By: '+allFilters.join(', '));
    }

    setTimeout(function () {
      self.resize();
    }, 100);
  },
  ajaxFilter: function (initialRender) {

    var queryString = 'published:true AND collections:'+this.collectionId;

    if (this.filters.length) {
      this.filters.forEach(function (filter) {
        queryString += ' AND '+filter;
      });
    }

    var self = this;

    // this.filter = queryString;

    this.$el.addClass('loading');

    this.index.search({
      query: this.query,
      hitsPerPage: 30,
      page: this.page,
      filters: queryString,
    }, function searchDone(err, content) {

      self.$el.removeClass('loading');

      if (err) { return console.log(err); };

      self.setFilterState();

      // $(window).scrollTop(0);

      if (content.hits.length > 0) {
        self.renderResults(content);

        if (!initialRender) {
          updateUrlParameters(self.filters, self.indexKey, self.page+1);
        }
      } else {
        self.renderNoResults();
      }
    });
  },
  removeFilter: function(filter) {
    this.filters.splice(this.filters.indexOf(filter), 1);
  },
  addFilter: function (filter) {
    this.filters.push(filter);
  },
  filter: function (e) {
    // console.log('filtering');
    this.page = 0;

    var $this = $(e.currentTarget);
    var filter = $this.data('key');
    var self = this;

    if ($this.hasClass('single-option')) {
      var $activeSiblings = $this.closest('.filter').find('.option.active');

      $activeSiblings.each(function () {
        if (this !== $this[0]) {
          var oldFilter = $(this).removeClass('active').data('key');

          if (oldFilter) {
            self.removeFilter(oldFilter);
          }
        }
      })
    }

    if (this.filters.indexOf(filter) !== -1) {
      this.removeFilter(filter);
      $this.removeClass('active');
    } else {
      this.addFilter(filter);
      $this.addClass('active');
    }

    this.ajaxFilter();
  },
  renderResults: function (content) {
    this.$container.find('.pagination').remove();
    this.$container.find('.products').empty().removeClass('no-results');

    var data = prepareProductData(content.hits);
    var $content = this.$container.find('.products');

    data.forEach(function(product) {
      $content.append( $( _.template(ProductLiTemplate)({ product: product }) ) );
    });
    
    setTimeout(window.fetchHiResCollectionImages, 0);

    this.renderPagination(content);
  },
  renderPagination: function (content) {
    var $pagination = $( _.template(PaginationTemplate)({ page: this.page, pages: content.nbPages }) );

    this.$container.append($pagination);

    var self = this;
    $pagination.find('> span').on('click', function (e) {
      var $this = $(e.currentTarget);
      var idx = $this.data('idx');

      if (idx !== undefined && !$this.hasClass('disabled') && idx !== self.page) {

        self.page = parseInt(idx);
        self.ajaxFilter();
        updateUrlParameters(self.filters, self.indexKey, idx+1);

        var zoom = $('html').css('zoom') || 1;
        zoom = parseFloat(zoom);
        var top = $('.section-header').outerHeight() || 0;
        $(window).scrollTop(top / zoom);

        e.preventDefault();
        e.stopPropagation();
      }
    });

  },
  renderNoResults: function () {
    // console.log('rendering no results');
    this.$container.find('.pagination').remove();
    this.$container.find('.products').empty();
    this.$container.find('.products').addClass('no-results');
  },
  reorder: function (e) {
    var val = $(e.currentTarget).val();
    this.indexKey = val;
    this.index = this.client.initIndex(val);
    this.page = 0;
    this.ajaxFilter();
  },
  events: {
    'click .filter .option': 'filter',
    'change .sort select': 'reorder',
    'click .filter .title': function (e) {
      if (window.App.touch && ($(window).width() < 765)) {
        $(document).off('click.'+this.guid);

        var $parent = $(e.currentTarget).parent();
        var self = this;

        this.$el.find('.filter.active').each(function () {
          if (this !== $parent[0]) {
            $(this).removeClass('active');
          }
        });

        if ($parent.hasClass('active')) {
          $parent.removeClass('active');
        } else {
          $parent.addClass('active');

          setTimeout(function () {
            $(document).on('click.'+self.guid, function(e) {
              const el = $parent.find('.options')[0];

              if (!$.contains(el, e.target) && el !== e.target) {
                $parent.removeClass('active');
                $(document).off('click.'+self.guid);
              }
            });
          }, 100);
        }
      }
    }
  }
});

var PageView = Backbone.View.extend({
  initialize: function () {
    this.guid = window.App.guid();
    new RefinementView({ el: this.$el.find('.refinement-block') });
  },
});

module.exports = PageView;

}());